import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, HelpersService } from '@base-shared/services';
import { isEmpty, clone } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '@eyrus/shared/services';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private auth: AuthService,
    private helpers: HelpersService,
    private translate: TranslateService,
    private analytics: AnalyticsService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const currentUser: any = this.auth.user;

    if (isEmpty(currentUser) || !this.auth.token)
      return this.notAuthorized();

    if (!currentUser.accounts || !currentUser.accounts.length) {
      return this.notAuthorized();
    }

    // identify on analytics
    if (!this.analytics.identified()) {
      this.analytics.registerUser(clone(currentUser.user));
      this.analytics.identify(currentUser.user.email);
    }

    const stateCheck = new Observable<boolean>((obs) => {
      // custom validations
      obs.next(true);
    });

    return stateCheck;
  }

  /**
   * Trigger not authorized flow
   */
  notAuthorized() {
    this.auth.logout();
    this.analytics.logout();
    this.helpers.infoMessage('', this.translate.instant('common.not-authorized'));
    this.router.navigate(['/auth/login']);
    return false;
  }
}
